import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { deleteItem, fetchData, handleAddItem, handleUpdateItem } from "../../utils/data";
import { Service } from "../../types";
import i18n from "../../i18n";
const lang = i18n.language === "ar" ? "ar" : "en";
export const fetchServiceAdmin = createAsyncThunk("get/ServiceAdmin", async (id:number) => {
        const data = await fetchData(`Service/getAmenityWithAllData?serviceId=${id}`,true);
        return data;
});
export const fetchServices = createAsyncThunk("get/Service", async () => {
        const data = await fetchData(`Service/getServices?lang=${lang}`);
        return data;
});
export const addService = createAsyncThunk("post/Service", async (ServiceData: any) => {
        await handleAddItem(ServiceData, "Service/addService", "POST");
        return ServiceData;
});
export const updateService = createAsyncThunk("PUT/Service", async ({data}: { data:any}) => {
        await handleUpdateItem(data, `Service/editService`, "PUT");
        return { ...data };
});
export const deleteService = createAsyncThunk("delete/Service", async (id: number) => {
        await deleteItem(`Service/deleteService?amenityID=`,id);
        return id;
});
interface ServiceState {
    services: Service[];
    service: Service | null;
    loading: boolean;
    error: string;
}

const initialState: ServiceState = {
    services: [],
    service: null,
    loading: false,
    error: ""
};

const serviceSlice = createSlice({
    name: "serviceSlice",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Fetch
            .addCase(fetchServices.pending, (state) => {
                state.loading = true;
                state.error = "";
            })
            .addCase(fetchServices.fulfilled, (state, action) => {
                state.loading = false;
                state.services = action.payload;
            })

             // Fetch service for admin with all languages
            .addCase(fetchServiceAdmin.pending, (state) => {
                state.loading = true;
                state.error = "";
            })
            .addCase(fetchServiceAdmin.fulfilled, (state, action) => {
                state.loading = false;
                state.service = action.payload;
            })

            // Add
            .addCase(addService.fulfilled, (state, action) => {
                state.services.push(action.payload);
            })

            // Update
            .addCase(updateService.fulfilled, (state, action) => {
                state.services = state.services.map((item) =>
                    item.id === action.payload.id ? action.payload : item
                );
            })
            // Delete
            .addCase(deleteService.fulfilled, (state, action) => {
                state.services = state.services.filter((item) => item.id !== action.payload);
            })
    }
});

export default serviceSlice.reducer;
